import APIClient from '@/shared/http/clients/api'

const resourceName = 'workshopbudget'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (mechanicalworkshopId = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/GetAll/${mechanicalworkshopId}`, config)
const GetAllPaging = (mechanicalworkshopId, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/GetAll/${mechanicalworkshopId}?limit=${limit}&index=${index}`, config)
const GetAllByName = (name, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/name/${name}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const WorkshopBudgetRepository = {
  GetAll,
  GetAllPaging,
  GetAllByName,
  GetById,
  Create,
  Update,
  Delete
}

export default WorkshopBudgetRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/workshopbudget.js